import { useQuery } from "react-query";
import { getLookups } from "components/photography/lib/photoData";

export const useLookups = ({ enabled, regularShotFilterKey }) => {
    const filterBulkUploadValues = (value) => value[regularShotFilterKey];

    return useQuery({
        queryKey: ["photographyLookups"],
        initialData: {
            packageTypes: [],
            editingSources: [],
        },
        queryFn: async () => {
            const lookups = await getLookups(true);

            return {
                ...lookups,
                groups: lookups.groups.filter(filterBulkUploadValues),
                editingSources: lookups.editingSources.filter(filterBulkUploadValues).map(({ editingSourceId, source }) => {
                    return {
                        text: source,
                        value: editingSourceId,
                    };
                }),
                imageViews: lookups.imageViews.filter(filterBulkUploadValues),
            };
        },
        enabled,
    });
};
